import { usageIds } from "../../../../constants/usageid.js";
export var ChartConfigurationSchemaIds;
(function (ChartConfigurationSchemaIds) {
    ChartConfigurationSchemaIds["CHART_CONFIGURATION"] = "chart-config";
})(ChartConfigurationSchemaIds || (ChartConfigurationSchemaIds = {}));
export var ChartConfigurationTags;
(function (ChartConfigurationTags) {
    ChartConfigurationTags["DEFAULT"] = "default";
})(ChartConfigurationTags || (ChartConfigurationTags = {}));
export const ChartConfigurationTagsMap = {
    [ChartConfigurationSchemaIds.CHART_CONFIGURATION]: [
        ChartConfigurationTags.DEFAULT
    ]
};
export const ChartConfigurationUsageIds = usageIds(ChartConfigurationTagsMap);
